import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = { class: "table wh800" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "txt-action-path" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "image-action"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick", "src", "title"]
const _hoisted_11 = {
  key: 0,
  class: "custom-select"
}
const _hoisted_12 = {
  key: 0,
  class: "loading-style"
}
const _hoisted_13 = {
  key: 1,
  class: "loading-style"
}

export function render(_ctx, _cache) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")
  const _component_c_loading = _resolveComponent("c-loading")
  const _component_c_empty = _resolveComponent("c-empty")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "table-scroll",
      style: _normalizeStyle(_ctx.styleList),
      ref: "tableBody",
      onScroll: _cache[1] || (_cache[1] = (...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
    }, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
              return _withDirectives((_openBlock(), _createElementBlock("th", {
                key: column,
                class: _normalizeClass(column?.className || '')
              }, _toDisplayString(_ctx.$t(column?.label || column)), 3)), [
                [_vShow, !column?.hidden]
              ])
            }), 128))
          ])
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataRows, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "hover-list"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (cell, key) => {
                    return _withDirectives((_openBlock(), _createElementBlock("td", {
                      key: key,
                      class: _normalizeClass(cell?.className || '')
                    }, [
                      _renderSlot(_ctx.$slots, "cell", {
                        cell: cell?.label || cell,
                        row: item
                      }, () => [
                        _createElementVNode("span", {
                          innerHTML: _ctx.tdValue(cell, item)
                        }, null, 8, _hoisted_4)
                      ])
                    ], 2)), [
                      [_vShow, !cell?.hidden]
                    ])
                  }), 128)),
                  (_ctx.actions?.value && _ctx.actions?.value.length)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        class: _normalizeClass(_ctx.actions?.className || ''),
                        style: _normalizeStyle(_ctx.hidden ? 'overflow: hidden !important;' : 'overflow: visible !important;')
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions?.value, (action, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "item-action"
                            }, [
                              (!action?.type)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                    (action?.isDisabled || _ctx.handleCondition(action, item))
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass([action?.className || '', action?.isDisabled || _ctx.handleCondition(action, item) ? _ctx.className(action?.className) : ''])
                                        }, _toDisplayString(_ctx.$t(action?.label || action)), 3))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          onClick: $event => (_ctx.handleAction(action, item)),
                                          class: _normalizeClass([action?.className || '', action?.isDisabled || _ctx.handleCondition(action, item) ? _ctx.className(action?.className) : ''])
                                        }, _toDisplayString(_ctx.$t(action?.label || action)), 11, _hoisted_7))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (action?.isDisabled || _ctx.handleCondition(action, item))
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: action?.type,
                                          class: _normalizeClass([action?.className || '', action?.isDisabled || _ctx.handleCondition(action, item) ? _ctx.className(action?.className) : '']),
                                          alt: ""
                                        }, null, 10, _hoisted_9))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          onClick: $event => (_ctx.handleAction(action, item)),
                                          src: action?.type,
                                          title: _ctx.$t(action?.label || action),
                                          class: _normalizeClass([action?.className || '', action?.isDisabled || _ctx.handleCondition(action, item) ? _ctx.className(action?.className) : '']),
                                          alt: ""
                                        }, null, 10, _hoisted_10))
                                  ]))
                            ]))
                          }), 128)),
                          (_ctx.isOption)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_CustomDropdown, {
                                  onChange: _ctx.onChangeDropdown,
                                  item: item,
                                  rows: _ctx.rowOptions
                                }, null, 8, ["onChange", "item", "rows"])
                              ]))
                            : _createCommentVNode("", true),
                          _renderSlot(_ctx.$slots, "action", { row: item })
                        ])
                      ], 6))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.loading || _ctx.isSecondLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_c_loading, { textLoading: _ctx.textLoading }, null, 8, ["textLoading"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loading && !_ctx.isSecondLoading && _ctx.dataRows && !_ctx.dataRows.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_c_empty, {
              onHandler: _cache[0] || (_cache[0] = $event => (_ctx.$emit('handler'))),
              is_try_again: true
            })
          ]))
        : _createCommentVNode("", true)
    ], 36)
  ]))
}